import { Button } from '@chakra-ui/react'
import { Export } from '../../icons'

interface ExportButtonProps {
  isOpen: boolean
  setOpen: {
    on: () => void
    off: () => void
    toggle: () => void
  }
}

export const ExportButton = ({ isOpen, setOpen }: ExportButtonProps) => {
  return (
    <Button variant="outline" onClick={setOpen.toggle}>
      <Export color="secondary.500" style={{ transform: 'rotate(180deg)' }} />
      {isOpen ? 'Skrýt export' : 'Export'}
    </Button>
  )
}
